<template>
  <div>
    <Header
      :show-pop="showPopup"
      @update:hide-pop="showPopup = false"
      @update:login="dialogLogIn = true"
    />
    <router-view
      @update:login="dialogLogIn = true"
      @update:show-popup="showPopup = true"
    />
    <Footer v-if="!$route.meta.hideFooter" />
    <log-in
      :show="dialogLogIn"
      @update:close="dialogLogIn = false"
    />
    <v-overlay
      :value="$store.state.miniLoading"
      opacity="0.1"
    >
      <v-progress-circular
        indeterminate
        color="primary lighten-4"
        class="mb-12"
      />
    </v-overlay>
  </div>
</template>

<script>
import Header from '@/layout/Header.vue';
import Footer from '@/layout/Footer.vue';
import LogIn from '@/components/LogIn.vue';

export default {
  name: 'Layout',
  components: {
    LogIn,
    Header,
    Footer,
  },
  data() {
    return {
      dialogLogIn: false,
      showPopup: false,
    };
  },
};
</script>
